<template>
	<div>
		<div class="head">
			<!-- <p v-if="!question">暂无数据</p> -->
			<div class="list">
				<p class="tophead">健康素养测试</p>
				<div
					class="list_box"
					v-for="(item, index) in list"
					:key="index"
				>
					<p>{{ item.description }}</p>
					<!-- 单选 -->
					<div>
						<a-radio-group v-model="item.value">
							<a-radio
								v-for="(child,
								childrenIndex) in item.questionItemResp"
								:key="childrenIndex"
								:style="radioStyle"
								:value="child.id"
								@change="onRadioChange(item.id, child.id)"
								>{{ child.text }}</a-radio
							>
						</a-radio-group>
					</div>
				</div>
			</div>
			<div class="btn" v-if="!show">
				<a-button type="primary" size="large" @click="submit"
					>提交测试</a-button
				>
			</div>
			<div class="result-box" v-if="show">
				<div class="result-text">
					测试结果:
					<span :style="{ color: resulet.color }">{{
						resulet.text
					}}</span>
					<span style="padding-left:25px;">答案：B、B、B、C、B、B、 C、C、A、C</span>
					<a-button @click="myclick" style="float:right;"
						>重新测试</a-button
					>
					<!-- <a-button
						@click="submit"
						type="primary"
						style="float:right;"
						>继续测试</a-button
					> -->
				</div>
				<div class="result-list">
					<template v-for="(item, index) in list">
						<p
							:key="'mypro' + index"
							:style="{
								background: resulet.slip.find(
									(i) => i == index + 1
								)
									? 'red'
									: 'green',
							}"
						>
							{{ index + 1 }}
						</p>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			question: {},
			list: [
				{
					description: '1.我国每年的“爱眼日”是哪一天？',
					value: '',
					questionItemResp: [
						{ id: 1, text: '3月15日' },
						{ id: 2, text: '6月6日' },
						{ id: 3, text: '9月10日' },
						{ id: 4, text: '12月10日' },
					],
				},
				{
					description:
						'2.《中国居民膳食指南》规定，成年人每天应摄入的谷类食物是多少克？',
					value: '',
					questionItemResp: [
						{ id: 1, text: '200～400克' },
						{ id: 2, text: '250～400克' },
						{ id: 3, text: '300～400克' },
						{ id: 4, text: '350～400克' },
					],
				},
				{
					description: '3．健康人每周至少运动几次？',
					value: '',
					questionItemResp: [
						{ id: 1, text: '2次' },
						{ id: 2, text: '3次' },
						{ id: 3, text: '5次' },
						{ id: 4, text: '7次' },
					],
				},
				{
					description: '4．一般情况下成人每天要保证多少小时睡眠？',
					value: '',
					questionItemResp: [
						{ id: 1, text: '4-5小时' },
						{ id: 2, text: '5-6小时' },
						{ id: 3, text: '7-8小时' },
						{ id: 4, text: '9-10小时' },
					],
				},
				{
					description:
						'5．与不吸烟者相比，吸烟者死于肺癌的风险提高几倍？',
					value: '',
					questionItemResp: [
						{ id: 1, text: '1－6倍' },
						{ id: 2, text: '6－13倍' },
						{ id: 3, text: '13－16倍' },
						{ id: 4, text: '16－21倍' },
					],
				},
				{
					description:
						'6.健康成年人连续两次献血时间至少应间隔多长时间？',
					value: '',
					questionItemResp: [
						{ id: 1, text: '不少于3个月' },
						{ id: 2, text: '不少于6个月' },
						{ id: 3, text: '不少于10个月' },
						{ id: 4, text: '不少于12个月' },
					],
				},
				{
					description:
						'7.《中国居民膳食指南》建议每人每天烹调油用量不应超过多少？',
					value: '',
					questionItemResp: [
						{ id: 1, text: '15克' },
						{ id: 2, text: '20克' },
						{ id: 3, text: '25克' },
						{ id: 4, text: '30克' },
					],
				},
				{
					description: '8．流感在我国多发生在哪个季节？',
					value: '',
					questionItemResp: [
						{ id: 1, text: '春夏季' },
						{ id: 2, text: '夏秋季' },
						{ id: 3, text: '冬春季' },
						{ id: 4, text: '秋冬季' },
					],
				},
				{
					description:
						'9．如果饮酒，成年女性一天饮入的酒中其酒精量不能超过多少？',
					value: '',
					questionItemResp: [
						{ id: 1, text: '15克' },
						{ id: 2, text: '20克' },
						{ id: 3, text: '25克' },
						{ id: 4, text: '30克' },
					],
				},
				{
					description: '10．随地吐痰容易传播下列哪种疾病？',
					value: '',
					questionItemResp: [
						{ id: 1, text: '肝炎' },
						{ id: 2, text: '艾滋病' },
						{ id: 3, text: '肺结核' },
						{ id: 4, text: '乙脑' },
					],
				},
			],
			show: false,
			answer: [2, 2, 2, 3, 2, 2, 3, 3, 1, 3],
			radioStyle: {
				display: 'block',
				height: '30px',
				lineHeight: '30px',
			},
			resulet: {},
			form: {},
			id: this.$route.query.id,
		}
	},
	async created() {},
	methods: {
		myclick() {
			this.list.forEach((item) => {
				item.value = ''
			})
			this.show = false
		},
		// 单选
		onRadioChange(id, childid) {
			this.form[id] = childid
		},
		// 提交
		async submit() {
			let { answer, list } = this
			let data = 0,
				arr = []
			try {
				list.forEach((item, index) => {
					if (!item.value) throw new Error()
					if (item.value != answer[index]) {
						// console.log(index,'错误')
						arr.push(index + 1)
						data++
					}
				})
				switch (true) {
					case data <= 2:
						this.resulet = {
							text: '满意',
							color: '#19CAAD',
							slip: [...arr],
						}
						break
					case data <= 4:
						this.resulet = {
							text: '较满意',
							color: '#A0EEE1',
							slip: [...arr],
						}
						break
					case data <= 6:
						this.resulet = {
							text: '一般',
							color: '',
							slip: [...arr],
						}
						break
					case data <= 8:
						this.resulet = {
							text: '较差',
							color: '#ECAD9E',
							slip: [...arr],
						}
						break
					case data <= 10:
						this.resulet = {
							text: '差',
							color: '#F4606C',
							slip: [...arr],
						}
						break
				}
				console.log(this.resulet)
				this.show = true
			} catch {
				this.$message.info('还有未选择的选项，请全部选择后提交！')
			}
		},
	},
	computed: {},
}
</script>

<style lang="less" scoped>
.head {
	width: 100%;
	height: 100%;
	overflow: auto;
	.tophead {
		font-size: 20px;
		font-weight: 600;
		margin-bottom: 5px;
		display: inline-block;
	}
	.list {
		.list_box {
			padding: 10px 0;
			border-bottom: 1px solid #ccc;
			p {
				margin: 0;
				margin-bottom: 5px;
				margin-right: 15px;
				font-size: 16px;
			}
			div {
				display: flex;
			}
		}
	}
	.btn {
		padding: 20px 0;
		text-align: center;
	}
	.result-box {
		margin-top: 20px;
		padding-bottom: 15px;

		.result-text {
			font-size: 16px;
			font-weight: bold;
		}
		.result-list {
			display: flex;
			align-items: center;
			padding-top: 10px;
			p {
				width: 30px;
				height: 30px;
				display: flex;
				align-items: center;
				justify-content: center;
				margin-right: 15px;
				user-select: none;
				border-radius: 100%;
				color: #fff;
			}
		}

		.bmi {
			margin: 10px;

			span {
				font-weight: bold;
				font-size: 18px;
			}
		}

		.desc {
			margin-top: 10px;
			font-size: 14px;
			color: #999;
		}
	}
}
</style>
